var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon2, _path8, _path9, _path10, _polygon3, _polygon4, _polygon5, _path11, _path12, _path13, _path14, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _path15, _path16, _polygon12, _path17, _path18, _path19, _polygon13, _polygon14, _polygon15, _path20, _path21, _path22, _path23, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _path24, _path25, _ellipse27, _circle, _path26, _polygon22, _polygon23, _polygon24, _path27, _path28, _path29, _polygon25, _path30, _ellipse28, _circle2, _path31, _polygon26, _polygon27, _polygon28, _path32, _path33, _path34, _polygon29, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSydlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 539.57 479.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{fill:#fff;}.cls-3{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "389.88 228.01 389.91 227.99 389.9 228 389.88 228.01"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.88,204.58c.18.34.37.67.56,1v-9.39C139.27,202.39,139.77,204.27,139.88,204.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M525.18,346c-.1-1.08-.19-2-.19-2.92,0-5.17-5.39-9.36-7.76-10.95-1.5-1.05-24.45-17.05-33.26-22.47a16.2,16.2,0,0,0-8.5-2.66c-6.15,0-10.06,4.35-11.57,7.22l-5.4,8.1C425,319,394.27,296.07,383.3,287c-.36-4.16-.61-8.67-.73-13.42.05-1.35.48-11.15,1.69-21.57,2.3-19.74,5.28-23.61,5.69-24.06a3,3,0,0,1,1.28-.46h0c.25,0,.49,0,.74,0a10.21,10.21,0,0,0,8.45-4.83c2.3,3.52,5.62,7.05,8.57,8.43a9.65,9.65,0,0,0,4.13.9c4.25,0,7.89-2.61,9-3.51,9.81-6.74,87.91-60.52,92.46-64.16,10-8,3-30.31-21.68-68.07C463.57,51.35,448.15,41.48,439.11,38a19.07,19.07,0,0,0-6.9-1.36A16,16,0,0,0,421,41.1c-7,4.77-77.84,52.81-84.25,57.46l-2.32,1.66c-5.7,4.06-11.08,7.89-8.62,14.28.93,2.42,3.81,6,6,8.43,5.31,5.78,8.35,6.52,10.4,6.52a6.35,6.35,0,0,0,4.55-1.87,24.16,24.16,0,0,1,5.8,1.83c8,4.28,12.18,7.43,14.26,9.32-4.8,4.76-14.81,11.73-27.69,19.21a271,271,0,0,1-33.28-11.12c-6.28-3.19-17.13-9-20.11-11.41-1-.82-2-1.63-2.91-2.42-3.61-3.06-6.73-5.71-10.68-6l-.51,0c-3.28,0-6.1,2.32-10.37,5.82-3.54,2.91-8,6.52-12.44,8.56l-2.59,1.19a265.85,265.85,0,0,1-42.52,15.87c-13.08-7.55-23.54-14.8-28.47-19.67,2.08-1.9,6.23-5,14.25-9.32a24.3,24.3,0,0,1,5.8-1.83,6.33,6.33,0,0,0,4.54,1.87c2.06,0,5.1-.74,10.41-6.52,2.18-2.38,5.06-6,6-8.43,2.46-6.39-2.92-10.22-8.62-14.28l-2.32-1.66c-6.41-4.65-77.22-52.69-84.25-57.46a16,16,0,0,0-11.19-4.5A19,19,0,0,0,103,38C94,41.48,78.53,51.35,49.2,96.29c-24.64,37.76-31.73,60-21.68,68.07,4.55,3.64,82.65,57.42,92.45,64.16,1.12.9,4.76,3.51,9,3.51a9.58,9.58,0,0,0,4.12-.9c3-1.4,6.35-5,8.66-8.55a9.28,9.28,0,0,0,1.17,1.76,8.7,8.7,0,0,0,6.21,3.09c1.8.13,2.5.3,3.36,1.12,1.2,1.16,3,4,5,11.14,2.5,9.06,2.95,29.81,2.54,47.06-11.11,9.23-41.79,32.19-75.52,35.57l-5.4-8.11C77.61,311.35,73.7,307,67.55,307a16.2,16.2,0,0,0-8.5,2.66c-8.81,5.42-31.77,21.43-33.26,22.47-2.38,1.59-7.76,5.78-7.76,10.95,0,.9-.09,1.84-.19,2.92a50,50,0,0,0-.26,7.81c.25,5.53,4.23,10.29,9.68,12.36-1.51,8.46-1.84,24.67,11.12,42.65.85,1.2,9.63,13,29.88,17.43A19.08,19.08,0,0,0,72,437.9c2.44,3.23,5.23,4.79,8.52,4.79a15,15,0,0,0,2.26-.2,8.8,8.8,0,0,1,.91-.1,1.57,1.57,0,0,1,.67.37,10.29,10.29,0,0,0,6.33,2.16c5.76,0,10.72-4.63,12.44-6.43l31.72-22,.26-.24c4-3.59,6.65-10,3.25-15.71-1-1.73-2.66-3.92-4.37-6.25-1.29-1.74-3.2-4.33-4.32-6.1,3.57-4.46,11.57-14.54,19.23-24.2,21.16,20.3,53.05,44.54,83.88,56a111.39,111.39,0,0,0,39.44,7.51c16.9,0,33.73-4.25,51.44-13,15-7.41,31-18.18,50.36-33.89l.07-.05,19.69-17.08c6.37,8,15.62,19.71,19.59,24.67-1.12,1.77-3,4.36-4.32,6.1-1.71,2.33-3.33,4.52-4.37,6.25-3.4,5.67-.7,12.12,3.25,15.71l.26.24,31.72,22c1.72,1.8,6.68,6.43,12.45,6.43a10.28,10.28,0,0,0,6.32-2.16,1.62,1.62,0,0,1,.67-.37,8.8,8.8,0,0,1,.91.1,15,15,0,0,0,2.26.2c3.29,0,6.08-1.56,8.52-4.79a19.08,19.08,0,0,0,3.73-11.65c20.25-4.43,29-16.22,29.88-17.43,13-18,12.63-34.19,11.12-42.65,5.46-2.07,9.43-6.83,9.68-12.36A50,50,0,0,0,525.18,346ZM389.88,228l0,0h0ZM140.44,205.57c-.19-.32-.38-.65-.56-1s-.61-2.19.56-8.4Zm379.75,148c-.22,5-5.7,8.66-10.94,8.43,0,0,8.21,20.07-8.89,43.77,0,0-8.89,13-31.46,16.19,0,0,2.28,7.07-2,12.76s-6.38,0-11.4,3.88-12.08-4.1-12.08-4.1l-31.91-22.12s-5-4.55-2.28-9.11,11.39-14.59,10-16.19c-1.1-1.28-18.1-22.73-24.73-31.11L370.7,376.59c-46.28,37.62-85.94,57.22-136.1,38.53-33.84-12.61-67.78-40.48-86.21-59-6.73,8.51-23.48,29.65-24.58,30.92-1.36,1.6,7.3,11.63,10,16.19s-2.27,9.11-2.27,9.11L99.65,434.5s-7.07,8-12.08,4.1-7.07,1.82-11.4-3.88-2-12.76-2-12.76c-22.57-3.19-31.46-16.19-31.46-16.19C25.56,382.07,33.77,362,33.77,362c-5.24.23-10.71-3.41-10.94-8.43s.45-7.52.45-10.49,5.47-6.61,5.47-6.61,24.17-16.87,33.06-22.34,12.76,2.74,12.76,2.74l7.3,10.94c38.41-2.48,73.14-29.8,83.36-38.57.25-8.62.83-38.29-2.66-50.94-4.11-14.9-8.66-15.81-13.07-16.11s-3.8-6.38-3.8-6.38V191.64s.15-5.42.58-10.76a6.7,6.7,0,0,0-5.82-2.38s-1.6,2.28-3.2,8.2-4.1,16.42-2,20.29,4.56,6.16,4.11,8.66-5,9.12-8.44,10.72-7.75-2.05-7.75-2.05-87.76-60.41-92.32-64.06-5.48-17.78,22.79-61.1,43.09-53.11,51.29-56.3,12.77,2.28,12.77,2.28,78,52.88,84.57,57.67,10.26,6.84,9.12,9.8-10.71,14.37-12.54,11-11.62,1.14-11.62,1.14c-17.56,9.34-18.7,14.13-18.7,14.13C173.84,147,196,160,203,164.05a279.92,279.92,0,0,0,48-17.93c9.57-4.33,17.78-14.13,20.74-13.9s6.16,3.65,10.72,7.29,21.2,12.09,21.2,12.09a276.36,276.36,0,0,0,36.23,12c7.82-4.49,28.54-16.84,33.69-24.75,0,0-1.14-4.79-18.69-14.13,0,0-9.8-4.56-11.63-1.14s-11.39-8-12.53-11,2.5-5,9.12-9.8,84.57-57.67,84.57-57.67,4.56-5.47,12.76-2.28,23,13,51.3,56.3,27.35,57.45,22.79,61.1S419,224.32,419,224.32s-4.33,3.64-7.75,2.05-8-8.21-8.44-10.72,2.05-4.78,4.11-8.66-.46-14.36-2.06-20.29-3.19-8.2-3.19-8.2a6.63,6.63,0,0,0-4.79,1.4,6.17,6.17,0,0,1,.06.88s.46,30.09.46,34.42-3,7.29-5.7,7.06a8,8,0,0,0-5,1.6c-7.75,6.38-9.34,49.7-9.34,49.7.15,6,.49,11.35,1,16.1,10.8,9.17,45.05,35.7,82.88,38.15l7.3-10.94s3.87-8.21,12.76-2.74,33.06,22.34,33.06,22.34,5.47,3.65,5.47,6.61S520.42,348.56,520.19,353.57Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.86,338.7c-5.19-1.15-17-6.86-23.66-34.6-8.66-36.24-1.82-86.62,16-88.67V184.08a4,4,0,0,0-3.7-4c-15.32-1.19-74.65-7.59-111.21-37a4.13,4.13,0,0,0-5.45.26C261,150.81,233,171.5,156.64,179.45a3.73,3.73,0,0,0-3.34,3.71v32.65a10.69,10.69,0,0,1,8.63,4.39c4.45,6.09,10.9,19.5,10.9,46.06,0,38.52-6.37,66.15-26.71,72.17a2,2,0,0,0-.85,3.32C158.92,355.27,225,417.89,274,414.44c52.07-3.68,110.69-57.72,123.66-73.26A1.54,1.54,0,0,0,396.86,338.7Zm-11.12,4.68C328.66,402.66,280.2,407.6,280.2,407.6c-59,4.92-111.77-52.43-121.84-64.07a2.78,2.78,0,0,1,.12-3.78c20.86-20.93,23.16-62.44,20.5-90.59-2.73-28.95-18.24-39.89-18.24-39.89V187.16c69.53-7.52,110.11-36.93,110.11-36.93,40.58,29.63,111.25,37.16,111.25,37.16v21.42c-18.24,19.15-18.93,47.42-18.93,47.42-2.73,59,16.78,79.81,22.44,84.57A1.77,1.77,0,0,1,385.74,343.38Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.76,251h17.33v-34.2s-1.37-28.95-18.46-28.72-24.17,17.1-26.45,43.08,3,43.55,17.33,66.57,13,47.19,5.24,48.33-8-28-6.61-36l-17.78-4.1-.23,24.16s-.23,45.82,29.18,49.47,19.38-72.72,12.54-88.68S214.54,248,215.68,230.47,231.64,214.06,227.76,251Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.33,183.28s14.82-3,18-1.82l5,68.62,5.24-69.3s16.64,1.82,18,4.1l-13.68,111v94.6a42.45,42.45,0,0,1-18.69.91L263.55,295Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M347.67,302.51c-.45-29.41-1.14-76.83-1.14-76.83s6.39-33.51-44.91-40.12V385.48s27.36-12.3,34.65-23.93S348.13,331.91,347.67,302.51Zm-17.55,28c-.46,8-4.79,13-8,13s-3.65-4.79-3.65-4.79l.23-115.57c3.42-1.6,4.79-.69,4.79-.69,6.61,2.28,6.61,16.87,6.61,16.87S330.58,322.57,330.12,330.55Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M204.06,110.79l-3.88,6.38s-7.52-3-11.85-2.5-21.66,7.29-37.16,24.84-23.25,37.16-24.39,51.07-.23,18.23,3.87,21.43c0,0,3.19,2.73.92,5.47l-2.28,2.73s.22.23-5.93-3.64-49.7-33.74-49.7-33.74,8.89-58.7,74.2-109Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "199.95 112.5 199.16 114.32 189.54 111.25 143.5 80.09 147.14 76.44 199.95 112.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.16,112.61s-19.45,9.12-25.84,17.48l-38.44-24.77,3.49-5L144,114.89,123.89,98.33l16.26-15.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.27,116l-12.46-8.66-12.46,14.58,4,.46S111.58,112.92,130.27,116Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.15,122.8l14.29,9.88-10.79,12.76S147.6,138,140.15,122.8Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "124.8 176.6 126.47 174.62 126.17 181.46 123.43 181.16 86.66 155.78 87.11 151.06 90.15 150.3 90.15 154.86 124.8 176.6"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "124.95 184.19 124.04 198.02 85.59 169.76 79.67 169.3 84.98 157.14 124.95 184.19"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "78.15 177.2 130.88 214.29 128.6 217.02 76.17 181 78.15 177.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.1,70.44l-6.38-4.1S74.35,113.75,64.09,176.22l4.56,3.19S86,115.92,144.1,70.44Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.16,62.69l-6.38-4.1S63.4,106,53.15,168.47l4.56,3.19S75,108.17,133.16,62.69Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122,54.71l-11.85-7.52a12,12,0,0,0-7.75,3.42C99,54,39.92,110.11,35.14,155.93l12.08,8.2S61.92,106.35,122,54.71Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123,117.93a19.15,19.15,0,1,0,19.15,19.15A19.15,19.15,0,0,0,123,117.93Zm.68,33.44a14.75,14.75,0,1,1,15-14.74A14.86,14.86,0,0,1,123.66,151.37Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "47.22 131.31 55.43 136.32 49.95 146.13 44.03 141.57 40.15 142.02 46.76 128.34 47.22 131.31"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "47.14 156.38 45.47 160.34 37.27 154.41 38.78 150 47.14 156.38"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "77.54 81.16 86.43 87.31 76.17 101.44 66.6 95.29 77.54 81.16"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "82.4 75.08 91.67 81 89.24 83.89 79.97 77.66 82.4 75.08"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "100.03 55.93 109.3 62.31 95.47 77.05 86.05 70.82 100.03 55.93"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "108.08 49.7 117.2 55.62 113.56 59.42 103.98 52.28 108.08 49.7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 125.15,
    cy: 64.49,
    rx: 2.54,
    ry: 0.97,
    transform: "translate(-11.27 99.27) rotate(-41.56)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 135.87,
    cy: 72.24,
    rx: 2.54,
    ry: 0.97,
    transform: "translate(-13.72 108.33) rotate(-41.56)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 100.11,
    cy: 88.75,
    rx: 2.54,
    ry: 0.97,
    transform: "translate(-33.65 91.55) rotate(-42.76)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 111.3,
    cy: 96.52,
    rx: 2.54,
    ry: 0.97,
    transform: "translate(-35.94 101.21) rotate(-42.76)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 56.64,
    cy: 165.81,
    rx: 2.54,
    ry: 0.97,
    transform: "translate(-118.36 174.4) rotate(-73.95)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 67.98,
    cy: 172.41,
    rx: 2.54,
    ry: 0.97,
    transform: "translate(-116.5 190.08) rotate(-73.95)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 78.01,
    cy: 145.4,
    rx: 2.54,
    ry: 0.97,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, -86.91, 140.26)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 111.35,
    cy: 76.98,
    rx: 10.79,
    ry: 0.97,
    transform: "translate(-21.82 101.28) rotate(-45)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 123.21,
    cy: 84.04,
    rx: 10.79,
    ry: 0.97,
    transform: "translate(-23.34 111.73) rotate(-45)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 90.26,
    cy: 101.17,
    rx: 10.79,
    ry: 0.97,
    transform: "translate(-45.24 105.81) rotate(-50.22)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 100.73,
    cy: 109.37,
    rx: 10.79,
    ry: 0.97,
    transform: "translate(-47.78 116.81) rotate(-50.22)"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 62.55,
    cy: 148.58,
    rx: 5.87,
    ry: 1.37,
    transform: "translate(-98.58 143.78) rotate(-65.46)"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 73.27,
    cy: 156.1,
    rx: 5.87,
    ry: 1.37,
    transform: "translate(-99.16 157.92) rotate(-65.46)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M185.82,168s-16.34,6.31-33.21,4.18c0,0-6.84-2.13-10.79-6.23,0,0,.92-9.42,15.2-19.61Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M337.88,110.79l3.88,6.38s7.52-3,11.85-2.5,21.66,7.29,37.16,24.84,23.25,37.16,24.39,51.07.23,18.23-3.87,21.43c0,0-3.19,2.73-.91,5.47l2.28,2.73s-.23.23,5.92-3.64,49.7-33.74,49.7-33.74-8.89-58.7-74.2-109Z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "341.99 112.5 342.79 114.32 352.4 111.25 398.45 80.09 394.8 76.44 341.99 112.5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M358.78,112.61s19.45,9.12,25.84,17.48l38.45-24.77-3.5-5L398,114.89l20.06-16.56-16.26-15.5Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M411.67,116l12.46-8.66,12.46,14.58-3.95.46S430.36,112.92,411.67,116Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M401.79,122.8l-14.29,9.88,10.79,12.76S394.34,138,401.79,122.8Z"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "417.14 176.6 415.47 174.62 415.77 181.46 418.51 181.16 455.29 155.78 454.83 151.06 451.79 150.3 451.79 154.86 417.14 176.6"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "416.99 184.19 417.9 198.02 456.35 169.76 462.27 169.3 456.96 157.14 416.99 184.19"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "463.8 177.2 411.06 214.29 413.34 217.02 465.77 181 463.8 177.2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M397.84,70.44l6.38-4.1s63.37,47.41,73.63,109.88l-4.56,3.19S456,115.92,397.84,70.44Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M408.78,62.69l6.38-4.1S478.54,106,488.79,168.47l-4.55,3.19S466.91,108.17,408.78,62.69Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M420,54.71l11.85-7.52a12,12,0,0,1,7.76,3.42C443,54,502,110.11,506.8,155.93l-12.08,8.2S480,106.35,420,54.71Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M399.81,137.08A19.15,19.15,0,1,0,419,117.93,19.15,19.15,0,0,0,399.81,137.08Zm3.5-.45a15,15,0,1,1,15,14.74A14.86,14.86,0,0,1,403.31,136.63Z"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "494.72 131.31 486.51 136.32 491.99 146.13 497.91 141.57 501.79 142.02 495.18 128.34 494.72 131.31"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "494.8 156.38 496.47 160.34 504.68 154.41 503.16 150 494.8 156.38"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "464.4 81.16 455.51 87.31 465.77 101.44 475.35 95.29 464.4 81.16"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "459.54 75.08 450.27 81 452.7 83.89 461.97 77.66 459.54 75.08"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "441.91 55.93 432.64 62.31 446.47 77.05 455.89 70.82 441.91 55.93"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "433.86 49.7 424.74 55.62 428.38 59.42 437.96 52.28 433.86 49.7"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 416.79,
    cy: 64.49,
    rx: 0.97,
    ry: 2.54,
    transform: "translate(92.02 333.56) rotate(-48.44)"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 406.07,
    cy: 72.24,
    rx: 0.97,
    ry: 2.54,
    transform: "translate(82.62 328.15) rotate(-48.44)"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 441.83,
    cy: 88.75,
    rx: 0.97,
    ry: 2.54,
    transform: "translate(76.71 352.91) rotate(-47.24)"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 430.64,
    cy: 96.52,
    rx: 0.97,
    ry: 2.54,
    transform: "translate(67.42 347.18) rotate(-47.24)"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 485.3,
    cy: 165.81,
    rx: 0.97,
    ry: 2.54,
    transform: "translate(-26.92 140.63) rotate(-16.05)"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 473.96,
    cy: 172.41,
    rx: 0.97,
    ry: 2.54,
    transform: "translate(-29.19 137.75) rotate(-16.05)"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 463.93,
    cy: 145.4,
    rx: 0.97,
    ry: 2.54,
    transform: "translate(-10.54 251.44) rotate(-30)"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 430.59,
    cy: 76.98,
    rx: 0.97,
    ry: 10.79,
    transform: "translate(71.69 327.02) rotate(-45)"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 418.74,
    cy: 84.04,
    rx: 0.97,
    ry: 10.79,
    transform: "translate(63.22 320.71) rotate(-45)"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 451.68,
    cy: 101.17,
    rx: 0.97,
    ry: 10.79,
    transform: "translate(39.83 312.41) rotate(-39.78)"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 441.21,
    cy: 109.37,
    rx: 0.97,
    ry: 10.79,
    transform: "translate(32.15 307.62) rotate(-39.78)"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 479.39,
    cy: 148.58,
    rx: 1.37,
    ry: 5.87,
    transform: "translate(-18.41 212.5) rotate(-24.54)"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 468.67,
    cy: 156.1,
    rx: 1.37,
    ry: 5.87,
    transform: "translate(-22.5 208.73) rotate(-24.54)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M356.12,168s16.34,6.31,33.21,4.18c0,0,6.84-2.13,10.79-6.23,0,0-.91-9.42-15.2-19.61Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M381.64,300.46s-.23,15.27,7.07,23.48l10.71,3.87L412,334.19s4.56,3.19,4.1,5.7-13.9,9.58-13.68,12.54,11.86,14.13,15.05,18.47a9.7,9.7,0,0,0,7.75,4.1s.68-9.12,2.28-13.45,11.17-15.05,17.33-19.38,1.14-8.43-5.93-9.57S388.48,315,381.64,300.46Z"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 464.73,
    cy: 375.72,
    rx: 37.5,
    ry: 36.44
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 463.93,
    cy: 376.02,
    r: 24.73
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M444.1,406.69,435,421.27l16,11.4,12.31-17.09s14.26,2.58,27.71-9.77A42.77,42.77,0,0,0,503.1,363.6c-.32-1.23-.69-2.53-1.1-3.87l11.63-16.87L496.3,331.91l-10,13.68s15.73,13.68,16,30.32-14.13,36-39.44,35.79A41.42,41.42,0,0,1,444.1,406.69Z"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "510.74 343.69 496.61 334.27 491.37 341.34 505.5 351.6 510.74 343.69"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "436.43 421.27 450.56 430.7 455.8 423.63 441.67 413.37 436.43 421.27"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "490.38 329.94 476.24 320.52 471 327.58 485.13 337.84 490.38 329.94"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M482.06,346.28l-2.17,2.39s-6-4.56-11.05-5.47C468.84,343.2,471.46,340.58,482.06,346.28Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M484.3,347.87l-1.67,2.58s21,15.35,7,42.25c0,0-13.38,22.19-43,9L445.39,404s28,17,47.88-11.25C493.27,392.7,507.4,367.93,484.3,347.87Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M444.79,400.15l-1.52,2.43s-9.58-7.75-9.43-13.37Z"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "436.58 409.54 431.79 417.17 416.63 407.14 421.65 398.71 436.58 409.54"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.85,300.46s.22,15.27-7.07,23.48l-10.72,3.87-12.53,6.38s-4.56,3.19-4.11,5.7,13.91,9.58,13.68,12.54-11.85,14.13-15,18.47a9.71,9.71,0,0,1-7.75,4.1s-.69-9.12-2.28-13.45S103.86,346.5,97.7,342.17s-1.14-8.43,5.93-9.57S154,315,160.85,300.46Z"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 77.75,
    cy: 375.72,
    rx: 37.5,
    ry: 36.44
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 78.55,
    cy: 376.02,
    r: 24.73
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.38,406.69l9.12,14.58-16,11.4L79.24,415.58S65,418.16,51.53,405.81A42.74,42.74,0,0,1,39.39,363.6c.32-1.23.68-2.53,1.09-3.87L28.86,342.86l17.32-10.95,10,13.68s-15.73,13.68-16,30.32,14.14,36,39.44,35.79A41.42,41.42,0,0,0,98.38,406.69Z"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "31.74 343.69 45.88 334.27 51.12 341.34 36.99 351.6 31.74 343.69"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "106.06 421.27 91.92 430.7 86.68 423.63 100.82 413.37 106.06 421.27"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "52.11 329.94 66.24 320.52 71.48 327.58 57.35 337.84 52.11 329.94"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.43,346.28l2.16,2.39s6-4.56,11.06-5.47C73.65,343.2,71,340.58,60.43,346.28Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.19,347.87l1.67,2.58s-21,15.35-7,42.25c0,0,13.37,22.19,43,9L97.09,404s-28,17-47.87-11.25C49.22,392.7,35.09,367.93,58.19,347.87Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.7,400.15l1.52,2.43s9.57-7.75,9.42-13.37Z"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "105.91 409.54 110.69 417.17 125.85 407.14 120.84 398.71 105.91 409.54"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 139.01,
    y: 196.48,
    width: 3.11,
    height: 10.41
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSydlogo);
export default __webpack_public_path__ + "static/media/sydlogo.4495b026729827a95ec5170ace5f3203.svg";
export { ForwardRef as ReactComponent };